import { UrlConstants } from "../url.constants";
export class ApiAdminConstants {
    static URL = UrlConstants.API_V2 + "Admin";
    static FUNCTION_SEND_MESSAGE_TO_ALL = "SendMessageToAll";
    static FUNCTION_SEND_MESSAGE_TO_ORGANISATION = "SendMessageToOrganisation";
    static FUNCTION_SEND_MESSAGE_TO_MODULE = "SendMessageToModule";
    static FUNCTION_SEND_MESSAGE_TO_USER = "SendMessageToUser";
    static FUNCTION_SEND_FEEDBACK_TO_AFLA = "SendFeedbackEmail";
    static FUNCTION_GET_JOB_INFORMATION = "GetJobInformation";
    static FUNCTION_IS_CLASSIC_WORKFLOW = "IsClassicWorkflow";
    static FUNCTION_ALLOW_OVERRIDE_PERCENTAGE_COMPLETE = "AllowOverridePercentageComplete";
    static FUNCTION_HAS_CLASSIC_WORKFLOW_JOBS = "HasClassicWorkflowJobs";
    static FUNCTION_UPGRADE_CLASSIC_WORKFLOW = "UpgradeClassicWorkflow";
    static FUNCTION_UPGRADE_APPLICATION_WORKFLOW = "UpgradeApplicationWorkflow";
    static FUNCTION_UPGRADE_ALL_APPLICATIONS_WORKFLOW = "UpgradeAllApplicationsWorkflow";
    static FUNCTION_GET_LATEST_WORKFLOW_UPGRADE_REPORT = "GetLatestWorkflowUpgradeReport";
    static FUNCTION_GET_PORTAL_URL = "GetPortalUrl";
}
